import alert_mixin from '@/utils/mixins/alert_mixin';
import esigning_workflows_computed, {
  create_esigning_workflows_data,
} from './esigning_workflows_helpers';
import esigning_workflows_methods from './esigning_workflows_methods';

export default {
  name: 'EsigningWorkflows',
  mixins: [alert_mixin],
  data: create_esigning_workflows_data,
  computed: esigning_workflows_computed,

  mounted() {
    this.fetch_entity_types();
    this.fetch_workflows();
  },

  methods: {
    ...esigning_workflows_methods,
  },
};
